module.exports = __webpack_public_path__ + "img/default.6d451b06.svg";